<template>
  <div class="home">
    <stepper v-if="currStep > 0" :curr-step="currStep" />
    <div v-if="currStep > 0" :is="contents[currStep]['content']" @reload="getStatusTahap"></div>
    <div v-if="currStep > 0" :is="contents[currStep]['list']" @reload="getStatusTahap"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import Stepper from './components/Stepper';
import KandidatContent from './components/kandidat/Content';
import KandidatIndex from './components/kandidat/Index';
import SeleksiContent from './components/seleksi/Content';
import SeleksiIndex from './components/seleksi/Index';
import KonfirmasiContent from './components/konfirmasi/Content';
import KonfirmasiIndex from './components/konfirmasi/Index';
import BaContent from './components/ba/Content';
import BaIndex from './components/ba/Index';
export default {
  name: 'index-borang',
  components: {
    Stepper,
    KandidatContent,
    KandidatIndex,
    SeleksiContent,
    SeleksiIndex,
    KonfirmasiContent,
    KonfirmasiIndex,
    BaContent,
    BaIndex,
  },
  data() {
    return {
      currStep: 0,
      contents: {
        1: {
          content: 'KandidatContent',
          list: 'KandidatIndex',
        },
        2: {
          content: 'SeleksiContent',
          list: 'SeleksiIndex',
        },
        4: {
          content: 'KonfirmasiContent',
          list: 'KonfirmasiIndex',
        },
        5: {
          content: 'KonfirmasiContent',
          list: 'KonfirmasiIndex',
        },
        6: {
          content: 'BaContent',
          list: 'BaIndex',
        },
        7: {
          content: 'BaContent',
          list: 'BaIndex',
        },
        8: {
          content: 'BaContent',
          list: 'BaIndex',
        },
        9: {
          content: 'BaContent',
          list: 'BaIndex',
        },
        10: {
          content: 'BaContent',
          list: 'BaIndex',
        },
      },
    };
  },

  computed: {
    step() {
      return this.$route.params.step || null;
    },
  },

  created() {
    this.getStatusTahap();
  },

  methods: {
    ...mapActions('peringkat', ['index']),

    async getStatusTahap() {
      const { psp_peringkat } = await this.index();

      if (this.step) {
        this.currStep = Number(this.step);
        return;
      }

      this.currStep = (psp_peringkat && psp_peringkat.k_tahap_peringkat_psp) || 1;
    },
  },
};
</script>
